module.exports = __webpack_public_path__ + "static/media/img_snake_flex_bottom_left.9913272a.svg";